import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { SearchDriverStatus } from '@/backend/market'
import { DriverMetricAdjustmentsApi } from '../services/DriverMetricAdjustmentsApi'
import type { DriverMetricAdjustmentEntity } from '../../domain/entities/DriverMetricAdjustmentEntity'
import type { DriverMetricAdjustmentFilterEntity } from '../../domain/entities/DriverMetricAdjustmentFilterEntity'
import { DriverMetricAdjustmentRepository } from '../../domain/repositories/DriverMetricAdjustmentRepository'
import { DriverMetricAdjustmentModel } from '../models/DriverMetricAdjustmentModel'

export class DriverMetricAdjustmentRepositoryImpl extends DriverMetricAdjustmentRepository {
  async getAdjustments(
    filters: DriverMetricAdjustmentFilterEntity
  ): Promise<PaginateEntity<DriverMetricAdjustmentEntity> | { error: true }> {
    try {
      const response = await DriverMetricAdjustmentsApi.getAdjustments({
        driverId: filters.driver?.id,
        regionId: filters.region?.id,
        metricType: filters.metricType,
        status: filters.status,
        recordDate: filters.recordDate,
        page: filters.page !== undefined ? filters.page + 1 : undefined,
        limit: filters.limit
      })
      const items = response.items?.map((item) => new DriverMetricAdjustmentModel(item)) ?? []

      return new PaginateEntity<DriverMetricAdjustmentEntity>(
        {
          count: response.count,
          page: response.page ? response.page - 1 : 0,
          limit: response.limit,
          items
        },
        items
      )
    } catch {
      return { error: true }
    }
  }

  async getAdjustment(id: string): Promise<DriverMetricAdjustmentEntity | { error: true }> {
    try {
      return new DriverMetricAdjustmentModel(await DriverMetricAdjustmentsApi.getAdjustment(id))
    } catch {
      return { error: true }
    }
  }

  async revokeAdjustment(
    id: string,
    reason: string
  ): Promise<DriverMetricAdjustmentEntity | { error: true }> {
    try {
      return new DriverMetricAdjustmentModel(
        await DriverMetricAdjustmentsApi.revokeAdjustment(id, reason)
      )
    } catch {
      return { error: true }
    }
  }

  async createAcceptanceAdjustment(data: {
    searchDriverId: string
    effectiveStatus: SearchDriverStatus
    reason: string
    idempotencyKey: string
  }): Promise<DriverMetricAdjustmentEntity | { error: true }> {
    try {
      return new DriverMetricAdjustmentModel(
        await DriverMetricAdjustmentsApi.createAcceptanceAdjustment(data)
      )
    } catch {
      return { error: true }
    }
  }

  async createShiftAdherenceAdjustment(data: {
    driverShiftId: string
    startAt: string
    endAt: string
    reason: string
    idempotencyKey: string
  }): Promise<DriverMetricAdjustmentEntity | { error: true }> {
    try {
      return new DriverMetricAdjustmentModel(
        await DriverMetricAdjustmentsApi.createShiftAdherenceAdjustment(data)
      )
    } catch {
      return { error: true }
    }
  }
}
